import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPaginationParams, IScannedInvoices } from '@interfaces';
import { ApiResponse } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class ScannedInvoicesService {
  constructor(private http: HttpClient) {}
  getScannedInvoices(params: IPaginationParams) {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.append(key, String((params as any)[key]));
      });
    }
    params?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      httpParams = httpParams.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>('/v1/admin/invoices', { params: httpParams });
  }
  getScannedInvoiceById(id: string | null) {
    return this.http.get<ApiResponse>(`/v1/admin/invoices/${id}`);
  }
  updateScannedInvoice(id: string | null, scannedInvoiceData: IScannedInvoices) {
    return this.http.put<ApiResponse>(`/v1/admin/invoices/${id}`, scannedInvoiceData);
  }
  exportInvoices(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '')
      .set('userId', filterData.userId ? filterData.userId : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      if (value?.$regex) {
        params = params.set(key, value.$regex);
      }
    });

    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };

    return this.http.post<HttpResponse<Blob>>(`/v1/admin/invoices/export`, filterData, options);
  }
}
